import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Footer = () => {

  // Load Ionicons once
  useEffect(() => {
    const script1 = document.createElement("script");
    script1.type = "module";
    script1.src = "https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js";
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.noModule = true;
    script2.src = "https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js";
    document.body.appendChild(script2);
  }, []);

  return (
    <>
      {/* Exact Wave Animations */}
      <style>
        {`
          @keyframes animateWave {
            0% { background-position-x: 1000px; }
            100% { background-position-x: 0px; }
          }

          @keyframes animateWave_02 {
            0% { background-position-x: 0px; }
            100% { background-position-x: 1000px; }
          }

          .wave1 {
            z-index: 1000;
            opacity: 1;
            bottom: 0;
            animation: animateWave 8s linear infinite;
          }

          .wave2 {
            z-index: 999;
            opacity: 0.5;
            bottom: 10px;
            animation: animateWave_02 10s linear infinite;
          }

          .wave3 {
            z-index: 1000;
            opacity: 0.2;
            bottom: 0;
            animation: animateWave 30s linear infinite;
          }

          .wave4 {
            z-index: 999;
            opacity: 0.7;
            bottom: 20px;
            animation: animateWave_02 20s linear infinite;
          }
        `}
      </style>

      <footer className="relative w-full bg-gradient-to-b from-[#3586ff] to-[#0A1931] min-h-[100px] px-[50px] py-[20px] flex flex-col justify-center items-center mt-32">
        {/* Waves - responsive height */}
        <div className="absolute top-[-80px] left-0 w-full h-[80px] sm:top-[-100px] sm:h-[100px]">
          <div className="absolute left-0 w-full h-full bg-[url('https://i.ibb.co/rZt4Nhg/wave.png')] bg-[length:1000px_100px] wave1"></div>
          <div className="absolute left-0 w-full h-full bg-[url('https://i.ibb.co/rZt4Nhg/wave.png')] bg-[length:1000px_100px] wave2"></div>
          <div className="absolute left-0 w-full h-full bg-[url('https://i.ibb.co/rZt4Nhg/wave.png')] bg-[length:1000px_100px] wave3"></div>
          <div className="absolute left-0 w-full h-full bg-[url('https://i.ibb.co/rZt4Nhg/wave.png')] bg-[length:1000px_100px] wave4"></div>
        </div>

        {/* Responsive menu links */}
        <ul className="relative flex flex-wrap flex-col sm:flex-row justify-center items-center my-[10px] gap-y-2 gap-x-4">
          {[
            { label: "Home", path: "/" },
            { label: "About", path: "/about" },
            { label: "Services", path: "/services" },
            { label: "Projects", path: "/projects" },
            { label: "Career", path: "/career" },
            { label: "Vendors", path: "/vendors" },
            { label: "Contact", path: "/contact" },
          ].map((item) => (
            <li key={item.label} className="list-none">
              <Link
                to={item.path}
                className="text-base sm:text-[1.2em] text-[#ccc] mx-2 sm:mx-[10px] inline-block transition-all duration-[900ms] opacity-75 hover:opacity-100 hover:text-white no-underline"
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Copyright - responsive text */}
        <p className="text-[#eee] text-center mt-4 mb-2 text-sm sm:text-[1.1em]">
          &copy;2026 Skyline MEP Consultants | All Rights Reserved
        </p>
      </footer>
    </>
  );
};

export default Footer;
